import request from '@/utils/request';
/* 列表 */
export function querySeLeNiuLifeVideoPageList(data) {
  return request({
    url: '/sele/niu/life/video/querySeLeNiuLifeVideoPageList',
    method: 'POST',
    data
  });
}
/* 增加 */
export function saveSeLeNiuLifeVideo(data) {
  return request({
    url: '/sele/niu/life/video/saveSeLeNiuLifeVideo',
    method: 'POST',
    data
  });
}
/* 修改 */
export function updateSeLeNiuLifeVideo(data) {
  return request({
    url: '/sele/niu/life/video/updateSeLeNiuLifeVideo',
    method: 'POST',
    data
  });
}
/* 修改的信息展示 */
export function fetchSeLeNiuLifeVideoDetailById(data) {
  return request({
    url: '/sele/niu/life/video/fetchSeLeNiuLifeVideoDetailById',
    method: 'POST',
    data
  });
}
/* 删除 */
export function removeSeLeNiuLifeVideoById(data) {
  return request({
    url: '/sele/niu/life/video/removeSeLeNiuLifeVideoById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/video.js